import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

import { ThematicRepository } from "../../thematics/repositories/thematic.repository";

@Component({
    selector: 'app-thematics-recommendation',
    templateUrl: './thematics-recommendation.component.html',
    styleUrls: ['./thematics-recommendation.component.scss'],
})
export class ThematicsRecommendationComponent implements OnInit, OnDestroy {
    recommendedThematics: any[] = [];

    loading = false;

    error: string | null = null;

    private destroy$ = new Subject<void>();

    @Input() hasDoneInitialTest!: boolean;

    constructor(
        private readonly thematicRepository: ThematicRepository,
        private readonly router: Router) {}

    ngOnInit(): void {
        this.fetchRecommendedThematics();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    goToOrientationPage(): void {
        this.router.navigate(['home', 'orientation']);
    }

    private fetchRecommendedThematics(): void {
        this.loading = true;
        this.error = null;
        
        this.thematicRepository.getTalkerRecommendedThematics()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (thematics) => {
                    this.recommendedThematics = thematics;
                    this.loading = false;
                },
                error: (err) => {
                    console.error('Error fetching recommended thematics:', err);
                    this.error = 'Failed to load recommendations';
                    this.loading = false;
                }
            });
    }
}